import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6a448e97"), n = n(), _popScopeId(), n);
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "mb-1" };
const _hoisted_3 = { class: "ms-2 mb-0 alert alert-light lh-1 p-0 inverse-indent" };
const _hoisted_4 = /*#__PURE__*/ _createTextVNode(" Menu: ");
const _hoisted_5 = {
    key: 0,
    class: "ms-2 mb-0 alert alert-light lh-1 p-0 inverse-indent"
};
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = {
    key: 1,
    class: "ms-2 mb-0 alert alert-light lh-1 p-0 inverse-indent"
};
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FilterInput = _resolveComponent("FilterInput");
    const _component_PluginPathLink = _resolveComponent("PluginPathLink");
    const _component_PluginComponent = _resolveComponent("PluginComponent");
    return (_openBlock(), _createBlock(_component_PluginComponent, {
        modelValue: _ctx.open,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.open) = $event)),
        infoPayload: _ctx.infoPayload,
        cancelBtnTxt: "Done",
        actionBtnTxt: "",
        onOnPopupDone: _ctx.onPopupDone,
        onOnUserArgChanged: _ctx.onUserArgChanged
    }, {
        default: _withCtx(() => [
            _createVNode(_component_FilterInput, {
                list: _ctx.loadedPlugins,
                extractTextToFilterFunc: _ctx.extractTextToFilterFunc,
                onOnFilter: _ctx.onFilter,
                modelValue: _ctx.filterStr,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.filterStr) = $event))
            }, null, 8, ["list", "extractTextToFilterFunc", "onOnFilter", "modelValue"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loadedPluginsToUse, (plugin) => {
                return (_openBlock(), _createElementBlock("span", {
                    key: plugin.pluginId
                }, [
                    (plugin.title !== '' && plugin.menuPath !== null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                            _createElementVNode("h6", _hoisted_2, _toDisplayString(plugin.title), 1),
                            _createElementVNode("p", _hoisted_3, [
                                _createElementVNode("small", null, [
                                    _hoisted_4,
                                    _createVNode(_component_PluginPathLink, { plugin: plugin }, null, 8, ["plugin"])
                                ])
                            ]),
                            (_ctx.creditsToShow(plugin) !== '')
                                ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                                    _createElementVNode("small", {
                                        innerHTML: _ctx.creditsToShow(plugin)
                                    }, null, 8, _hoisted_6)
                                ]))
                                : _createCommentVNode("", true),
                            (_ctx.citationsToShow(plugin) !== '')
                                ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                                    _createElementVNode("small", {
                                        innerHTML: _ctx.citationsToShow(plugin)
                                    }, null, 8, _hoisted_8)
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("p", {
                                innerHTML: plugin.intro + ' ' + plugin.details,
                                class: "ms-2 mt-1"
                            }, null, 8, _hoisted_9)
                        ]))
                        : _createCommentVNode("", true)
                ]));
            }), 128))
        ]),
        _: 1
    }, 8, ["modelValue", "infoPayload", "onOnPopupDone", "onOnUserArgChanged"]));
}
